import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { updateUserPassword } from "../../redux/actions";
import { Button, Input } from "../../components";

import { AccessContainer, AccessHeading, AccessList, AccessButton } from './styles';

const PasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'Password is too short. Minimum length is 8 characters')
    .required('Password is required'),
  newPasswordConfirmation: Yup.string()
    .min(8, 'Password is too short. Minimum length is 8 characters')
    .required('Password is required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onSetPassword: updateUserPassword,
}, dispatch);

@connect(null, mapDispatchToProps)
class BookingAccessPass extends Component {
  static propTypes = {
    onSetPassword: PropTypes.func,
  };

  handleFormSubmit = ({ newPassword }) => {
    const { onSetPassword } = this.props;

    onSetPassword({ newPassword });
  };

  render() {
    const { handleFormSubmit } = this;

    return (
      <AccessContainer>
        <AccessHeading>Access Pass In Future</AccessHeading>
        <Formik
          initialValues={{
            newPassword: '',
            newPasswordConfirmation: '',
          }}
          validationSchema={PasswordSchema}
          onSubmit={handleFormSubmit}
        >
          {({errors, touched, handleBlur, handleChange, values}) => (
            <Form>
              <AccessList>
                <li>
                  <p>Password</p>
                  <Input
                    htmlType="password"
                    name="newPassword"
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.newPassword}
                    hasError={errors.newPassword && touched.newPassword}
                    errors={errors.newPassword}
                    placeholder="Create a new password"
                  />
                </li>
                <li>
                  <p>Confirm password</p>
                  <Input
                    htmlType="password"
                    name="newPasswordConfirmation"
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.newPasswordConfirmation}
                    hasError={errors.newPasswordConfirmation && touched.newPasswordConfirmation}
                    errors={errors.newPasswordConfirmation}
                    placeholder="Confirm a new password"
                  />
                </li>
              </AccessList>
              <AccessButton>
                <Button theme="primary" htmlType="submit">
                  Confirm
                </Button>
              </AccessButton>
            </Form>
          )}
        </Formik>
      </AccessContainer>
    );
  }
}

export default BookingAccessPass;
